import {
	Box,
	Card,
	CardContent,
	Divider,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { formatCurrency } from "../../utils";
import {
	formatEventDisplayName,
} from "../payments-import/payment-import-logic";
import EventPaymentsTable from "./EventPaymentsTable";

type PaymentForEvent = {
	id?: number;
	paypal_transaction_code: string | null;
	type: "paypal" | "cash";
	amount_cents: number;
	datetime: string | null;
	description: string | null;
};

type UserEvent = {
	event_id: number;
	event_date: string;
	participant_count: number;
	event_total_cost_cents: number;
	payments: PaymentForEvent[];
	paid_cents: number;
	outstanding_cents: number;
	fully_paid: boolean;
};

type UserStatus = {
	user_id: string;
	displayname: string | null;
	email: string | null;
	events: UserEvent[];
	total_event_cost_cents: number;
	total_paid_cents: number;
	total_outstanding_cents: number;
};

export default function UserOutstandingCard({ user }: { user: UserStatus }) {
	// Calculate cost of events that have no associated payments
	const eventsWithNoPayments = user.events.filter((e) => (e.payments ?? []).length === 0);
	const costUnpaidEventsCents = eventsWithNoPayments.reduce((s, ev) => {
		if (ev.participant_count > 0) {
			const share = Math.round(ev.event_total_cost_cents / ev.participant_count);
			return s + share;
		}
		return s + ev.event_total_cost_cents;
	}, 0);

	return (
		<Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', minWidth: 500 }}>
			<CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
				<Stack spacing={1}>
					<Typography variant="h6">
						{user.displayname ?? user.email ?? "Unbekannt"}
					</Typography>

					<EventPaymentsTable events={user.events} />


				{user.total_outstanding_cents !== costUnpaidEventsCents && (
					<Box sx={{ display: "flex", justifyContent: "space-between", pt: 1 }}>
						<Typography variant="body2">Saldo insgesamt</Typography>
						<Typography variant="body2">{formatCurrency(user.total_outstanding_cents)}</Typography>
					</Box>
				)}

				<Box sx={{ display: "flex", justifyContent: "space-between", pt: user.total_outstanding_cents === costUnpaidEventsCents ? 1 : 0 }}>
					<Typography variant="body2" fontWeight="bold">Kosten (Events ohne Zahlungen)</Typography>
					<Typography variant="body2" fontWeight="bold" color="error.main">
						{formatCurrency(costUnpaidEventsCents)}
					</Typography>
				</Box>
				</Stack>
			</CardContent>
		</Card>
	);
}
